import Dexie from "dexie";
import { IDatabaseUpgrade } from "../database-upgrade";

/**
 * The class responsible for applying upgrades to a Dexie database instance.
 */
export class DatabaseUpgradeManager {
	/**
	 * @constructor
	 * Private constructor to prevent this class from being instantiated because typescript doesn't support static classes.
	 */
	private constructor() { }

	/**
	 * Applies the upgrades to the database.
	 * @param dexieInstance The database instance to upgrade.
	 * @param upgrades The upgrades to apply.
	 */
	public static ApplyUpgrades(dexieInstance: Dexie, upgrades: IDatabaseUpgrade[]): void {
		upgrades.forEach((upgrade: IDatabaseUpgrade) => upgrade.Upgrade(dexieInstance));
	}
}